import { useOrganizationApi } from "~/api/GeneratedApi";
import { useCustomMutation } from "./useCustomMutation";
import { useCustomQuery } from "./useCustomQuery";

export const useOrganizationRoles = ({
  organizationId,
}: {
  organizationId: number | undefined | string;
}) => {
  const { getOrganizationRoles, toggleRoleNotification, getOrganizationUsers } =
    useOrganizationApi();

  const { isLoading, data: roles } = useCustomQuery(
    { key: "organization-roles", id: organizationId as number },
    () => getOrganizationRoles(organizationId as number),
    { enabled: organizationId !== undefined && organizationId !== "" },
  );

  const { data: users } = useCustomQuery(
    { key: "organization-users", id: organizationId as number },
    () => getOrganizationUsers(organizationId as number),
    { enabled: organizationId !== undefined && organizationId !== "" },
  );

  const { mutateAsync: mutateRoleNotificationAsync } = useCustomMutation(
    ({ orgId, roleId }: { orgId: number; roleId: number }) =>
      toggleRoleNotification(orgId, roleId),
  );

  return { roles, isLoading, mutateRoleNotificationAsync, users };
};
